<template>
  <b-notification class="kpt-global-notification" type="is-warning" :active.sync="globalNotificationActive" aria-close-label="Close">
    <h3>Global Notification</h3>
  </b-notification>
</template>
<style lang="scss" scoped>
.kpt-global-notification {
  border-radius: 0 !important;
  padding: 0.75rem !important;
}
</style>
<script>
export default {
  computed: {
    globalNotificationActive() {
      return this.$store.state.system.globalNotificationActive;
    }
  }
}
</script>
